import { render, staticRenderFns } from "./ProgramOutcomeDefinitionSelectbox.vue?vue&type=template&id=7d1d4c74"
import script from "./ProgramOutcomeDefinitionSelectbox.vue?vue&type=script&lang=js"
export * from "./ProgramOutcomeDefinitionSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports